import { Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

/**
 *
 * @param root0
 * @param root0.api
 * @param root0.allSelected
 */
export default function SelectAllHeader({ api, allSelected }) {
  const handleSelectAll = () => {
    api?.getRenderedNodes().forEach((node) => {
      if (node.selectable) {
        node.setSelected(!allSelected);
      }
    });
  };

  return <StyledCheckbox checked={allSelected} onClick={handleSelectAll} />;
}

const StyledCheckbox = withStyles({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0px',
    width: '100%',
  },
})(Checkbox);
